import PropTypes from 'prop-types';
import React from 'react';
import { Box, Card, IconButton, Typography } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useHistory } from 'react-router-dom';
import logo from 'utils/images/logo-tattersall.png';

export const BRAND_BLUE = '#004B93';
export const BRAND_BLUE_DARK = '#00173F';

// Estándar tipográfico compartido por las 4 vistas de autenticación.
export const AUTH_FONTS = {
  title: '1.6rem',
  subtitle: '1rem',
  field: '1.05rem',
  helper: '0.85rem',
  link: '1rem',
  button: '1.05rem',
};

/**
 * Shell común de las vistas de autenticación: fondo azul, tarjeta blanca
 * centrada, logo arriba, botón de volver opcional, título y subtítulo.
 * Garantiza el mismo look & tipografía en login, registro, recuperar
 * contraseña y validación de código.
 */
function AuthLayout({ title, subtitle, onBack, maxWidth = 460, children }) {
  const history = useHistory();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        overflowX: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: { xs: 2, sm: 4 },
        background: `linear-gradient(135deg, ${BRAND_BLUE_DARK} 0%, #072a68 100%)`,
      }}>
      <Card
        sx={{
          width: '100%',
          maxWidth,
          borderRadius: 4,
          overflow: 'hidden',
          boxSizing: 'border-box',
          boxShadow: '0 20px 60px rgba(0,0,0,0.35)',
        }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            p: { xs: 3, sm: 4.5 },
            width: '100%',
            minWidth: 0,
            boxSizing: 'border-box',
          }}>
          {/* Logo arriba, centrado */}
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
            <img
              src={logo}
              alt="logo"
              style={{ height: 64, cursor: 'pointer' }}
              onClick={() => history.push('/')}
            />
          </Box>

          {(title || onBack) && (
            <Box sx={{ position: 'relative', textAlign: 'center' }}>
              {onBack && (
                <IconButton
                  size="small"
                  onClick={onBack}
                  sx={{ position: 'absolute', left: 0, top: 0 }}>
                  <ArrowBackIosNewIcon fontSize="small" />
                </IconButton>
              )}
              {title && (
                <Typography sx={{ fontWeight: 700, color: BRAND_BLUE, fontSize: AUTH_FONTS.title }}>
                  {title}
                </Typography>
              )}
              {subtitle && (
                <Typography sx={{ color: 'text.secondary', fontSize: AUTH_FONTS.subtitle, mt: 0.5 }}>
                  {subtitle}
                </Typography>
              )}
            </Box>
          )}

          {children}
        </Box>
      </Card>
    </Box>
  );
}

AuthLayout.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  onBack: PropTypes.func,
  maxWidth: PropTypes.number,
  children: PropTypes.node,
};

export default AuthLayout;
